import { render, staticRenderFns } from "./ContactEditDefault.vue?vue&type=template&id=a86c76da&scoped=true"
import script from "./ContactEditDefault.vue?vue&type=script&lang=ts"
export * from "./ContactEditDefault.vue?vue&type=script&lang=ts"
import style0 from "./ContactEditDefault.vue?vue&type=style&index=0&id=a86c76da&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86c76da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a86c76da')) {
      api.createRecord('a86c76da', component.options)
    } else {
      api.reload('a86c76da', component.options)
    }
    module.hot.accept("./ContactEditDefault.vue?vue&type=template&id=a86c76da&scoped=true", function () {
      api.rerender('a86c76da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactEditDefault.vue"
export default component.exports